export default __webpack_public_path__ + "static/media/img_4.9c35b253.JPG";